import { createInertiaApp } from "@inertiajs/vue3"
import { definePreset } from "@primeuix/themes"
import Material from "@primeuix/themes/material"
import PrimeVue from "primevue/config"
import ConfirmationService from "primevue/confirmationservice"
import ToastService from "primevue/toastservice"
import Tooltip from "primevue/tooltip"
import { createApp, type DefineComponent, h } from "vue"
import { apolloClient } from "../queries/client"

import Layout from "../layout/Layout.vue"

const TrellisPreset = definePreset(Material, {
  semantic: {
    primary: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554",
    },
  },
  components: {
    menu: {
      css: () => `.p-menu { min-width: auto; }`,
    },
  },
})

createInertiaApp({
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  //
  title: (title) => (title ? `${title} | Trellis` : "Trellis"),

  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    const pages = import.meta.glob<DefineComponent>("../pages/**/*.vue", {
      eager: true,
    })
    const page = pages[`../pages/${name}.vue`]

    if (!page) {
      throw new Error(`Page ${name} not found`)
    }

    const component = page.default
    if (component.layout !== false) {
      component.layout = component.layout || Layout
    }

    return page
  },

  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(PrimeVue, {
        theme: {
          preset: TrellisPreset,
          options: {
            darkModeSelector: false,
          },
        },
      })
      .use(ToastService)
      .use(ConfirmationService)
      .directive("tooltip", Tooltip)
      .provide("apollo", apolloClient)
      .mount(el)
  },
})
